import React from 'react'
import InputBox from '../../../Components/Input';
import { FiMail } from 'react-icons/fi';
import Logo from "../../../assets/images/ssc-logo.png";
import LoginImage from "../../../assets/images/login-img.png";
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  return (
    <section className="bg-gray-100 dark:bg-dark h-screen">
      <div className="flex flex-wrap h-full">
        <div className="relative w-1/3 h-full overflow-hidden rounded-lg bg-white px-10 py-16 flex flex-col justify-center sm:px-12 md:px-24">
          <div className="mb-10">
            <a href="/#" className="mx-auto inline-block">
              <img src={Logo} alt="logo" />
            </a>
          </div>
          <h3 className="text-gray-900 font-bold text-2xl">Forgot Password</h3>
          <p className="my-5">
            Enter your email address and we will send you instructions on how to create a new password.
          </p>
          <form>
            <div className="my-4">
              <InputBox
                type="email"
                name="email"
                placeholder="Enter your email"
                label="Email"
                iconRight={<FiMail />}
              />
            </div>
            <div className="my-8">
              <input
                type="submit"
                value="Submit"
                className="w-full cursor-pointer rounded-lg border border-secondary bg-secondary px-5 py-3 text-base font-medium text-white transition hover:bg-opacity-90"
              />
            </div>
            <div className="text-center mb-5">
              <Link
                to={'/login'}
                className="mb-2 text-base font-semibold text-secondary hover:underline"
              >
                Back to Login
              </Link>
            </div>
          </form>

          <div></div>
        </div>
        <div className="flex justify-center items-center w-2/3">
          <img src={LoginImage} alt="LoginImage" />
        </div>
      </div>
    </section>
  )
}
export default ForgotPassword;